import { fetchList } from './utils'

export const fetchBroadcasts = language => (
  fetchList(0, {}, 'broadcasts', 1000, language)
)
